import styles from './style.module.css';

export default function ToggleSwitch({leftText,rightText,checked=false,onChange}){
    return(
        <div className={styles['switch']}>
            <label className={styles["switch-label"]}>
                <input 
                  className={styles['switch-input']} 
                  type="checkbox" 
                  checked={checked}
                  onChange={onChange}
                ></input>
                <span 
                className={styles["switch-slider"]}
                style={{
                    '--content':`"${checked?rightText:leftText}"`
                }}></span>
            </label>
            <div className={styles['switch-text']}>
                <span>{leftText}</span>
                <span>{rightText}</span>
            </div>
        </div>
    )
}